<template>
  <div class="pof w100 h100 t0 l0 zi100 flex aic jcc" :class="{'has-bg': background}" v-if="type">
    <div class="login flex por">
      <div class="login-left por tac" :class="type + '-left'">
        <template v-if="type === 'bind-phone'">
          <img src="../../assets/images/login/login-left-follow.png" class="poa left-bg"/>
          <div class="por zi1">
            <img :src="wxBind.icon || userInfo.icon" alt="" class="user-avatar">
            <div class="user-name">亲爱的<span class="user-name-inner"> {{userInfo.realname || wxBind.nickname || ('用户' + userInfo.username)}}</span>
            </div>
            <div class="welcome">欢迎来到格灵云课堂</div>
          </div>
        </template>
      </div>
      <div class="login-right por">
        <i class="poa close login-icon ico-1 csp" @click="type = ''"></i>
        <div class="right-inner" :class="type">
          <div class="login-tip flex aie">
            <span class="big">{{type === 'bind-phone' ? '绑定手机号码' : type === 'setting-pwd' ? '密码设置' : '登录后'}}</span>
            <span class="small">{{type === 'bind-phone' ? '为了您的账户安全，请先绑定手机号！' : '立即学习！'}}</span>
          </div>
          <div class="inner por" ref="inner">
            <template v-if="type === 'home'">
              <div class="por" v-show="prevLoginType === 'wx'">
                <triangle-popup class="abs-c b0" type="bottom" content="上次登录"></triangle-popup>
              </div>
              <div class="to-wx to csp" @click="changeType('wx')"><i class="login-icon ico-5"></i>微信登录</div>
              <div class="por" v-show="prevLoginType === 'phone-code' || prevLoginType === 'phone-pwd'">
                <triangle-popup class="abs-c b0" type="bottom" content="上次登录"></triangle-popup>
              </div>
              <div class="to-phone to csp" @click="changeType('phone')"><i class="login-icon ico-6"></i>手机号登录</div>
              <div class="agreement flex aic lh1">
                <i class="login-icon csp" :class="checkAgreement ? 'ico-3' : 'ico-2'"
                   @click="checkAgreement = !checkAgreement"></i>
                <div class="flex">
                  同意
                  <span class="to-agreement csp" @click="changeEvent('user_protocol')">《用户协议》</span>
                  及
                  <span class="to-agreement csp" @click="changeEvent('privacy')">《隐私政策》</span>
                </div>
              </div>
            </template>
            <template v-else-if="type === 'wx'">
              <div class="qr-code tac">
                <div class="qr-code-inner ovh">
                  <wx-img @is-use="type = ''" :to="$route.fullPath" :size="170"></wx-img>
                </div>
              </div>
              <div class="message tac">
                <i class="login-icon ico-7 mr5"></i>微信扫码关注即可登录
              </div>
            </template>
            <template
                    v-else-if="type === 'phone-code' || type === 'phone-pwd' || type === 'bind-phone' || type === 'setting-pwd'">
              <div class="change-phone-type flex jcb aic" v-show="type === 'phone-pwd' || type === 'phone-code'">
                <div class="csp" :class="{active: type === 'phone-code'}" @click="type = 'phone-code'">
                  <div class="por popup" v-show="prevLoginType === 'phone-code'">
                    <triangle-popup class="abs-c b0" type="bottom" content="上次登录"></triangle-popup>
                  </div>
                  验证码登录
                </div>
                <div class="csp" :class="{active: type === 'phone-pwd'}" @click="type = 'phone-pwd'">
                  <div class="por popup" v-show="prevLoginType === 'phone-pwd'">
                    <triangle-popup class="abs-c b0" type="bottom" content="上次登录"></triangle-popup>
                  </div>
                  密码登录
                </div>
              </div>
              <div class="df-input phone-input ovh">
                <i-input @on-keyup="changeInput('phone')" placeholder="请输入手机号" v-model="form.phone" @on-enter="phoneLoginSubmit"></i-input>
              </div>
              <template v-if="type === 'phone-code' || type === 'bind-phone' || type === 'setting-pwd'">
                <div class="df-input code-input ovh flex aic" :class="{'can-click': codeStatus}">
                  <i-input @on-keyup="changeInput('verifycode')" placeholder="请输入验证码" maxlength="6" class="flex-1"
                           v-model="form.verifycode" @on-enter="phoneLoginSubmit"></i-input>
                  <div class="send-code-btn csp tac pl10 ml10">
                    <countdown @starting="sendCode" @ending="countdownEnd"></countdown>
                  </div>
                </div>
              </template>
              <template v-if="type === 'phone-pwd' || type === 'setting-pwd'">
                <div class="df-input pwd-input ovh">
                  <i-input @on-keyup="changeInput('password')" placeholder="请输入密码" :type="showPwd ? '' : 'password'" v-model="form.password" @on-enter="phoneLoginSubmit">
                    <i slot="suffix" class="login-icon" :class="showPwd ? 'ico-12' : 'ico-11'"
                       @click="showPwd = !showPwd"></i>
                  </i-input>
                </div>
                <div class="tar forget-pwd csp" v-show="type === 'phone-pwd'" @click="type = 'setting-pwd'">忘记密码？</div>
              </template>
              <div class="login-submit tac csp"  @click="phoneLoginSubmit">{{type === 'bind-phone' ? '立即学习' : type ===
                'setting-pwd' ? '确定' : '登录'}}
              </div>
            </template>
          </div>
          <template v-if="type === 'wx' || type === 'phone-pwd' || type === 'phone-code'">
            <div class="change-phone lh1 csp flex aic jcc" @click="type = type === 'wx' ? 'phone' : 'wx'">使用{{type ===
              'wx' ?
              '手机号码' : '微信'}}登录<i
                      class="login-icon ml5"
                      :class="type === 'wx' ? 'ico-8' : 'ico-9'"></i>
            </div>
            <div class="agreement tac lh1">登录即同意
              <span class="to-agreement csp" @click="changeEvent('user_protocol')">《用户协议》</span>
              及
              <span class="to-agreement csp" @click="changeEvent('privacy')">《隐私政策》</span></div>
          </template>
          <div class="bind-tip flex aic jcc" v-else-if="type === 'bind-phone'">
            <span>无法绑定，请联系</span>
            <poptip-item type="kf" :item="kfItem" show-slot placement="right">
              <span slot="show" class="kf csp">客服<icon type="ios-arrow-forward" color="#1177FF" size="14"/></span>
            </poptip-item>
          </div>
        </div>
      </div>
      <div class="bind-error w100 h100 t0 l0 pof zi1 flex jcc aic tac" v-show="bindErr">
        <div class="bind-error-box por bsb lh1">
          <i class="login-icon ico-13 poa csp" @click="bindErr = ''"></i>
          <div class="header tal">您的手机号<span class="red">已经被使用</span>，为了您的账号安全，请联系客服进行账号信息合并。</div>
          <div class="qr-code mlr-auto">
            <img src="" alt="" class="vat w100 h100">
          </div>
          <div class="footer">微信扫一扫添加客服</div>
          <div class="phone">联系电话：19303035318</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex';

  export default {
    name: "Login",
    computed: {
      ...mapGetters(['prevLoginType', 'userInfo']),
    },
    watch: {
      type(val) {
        this.typeChange();
        if (!val && this.wxBind.openid) {
          this.setQrState('');
          location.replace(location.href.replace(/[&?]((code=\w+)|(state=\w+)|(isBindWx=\w+))/gi, ''));
        }
      },
      value(val) {
        this.type = val;
      },
    },
    props: {
      background: {
        type: Boolean,
        default: true,
      },
      value: {
        type: String,
        default: 'home',
      },
      // wxlogin 绑定手机时微信数据
      wxBind: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    created() {
      this.type = this.value;
      this.typeChange();
    },
    data() {
      return {
        type: 'home',
        checkAgreement: true,
        codeStatus: true,
        showPwd: false,
        lockSubmit: false,
        bindErr: '',
        form: {},
        kfItem: {
          type: 'kf'
        },
      }
    },
    methods: {
      ...mapMutations(['setPrevLoginType', 'setNewApiToken', 'setQrState', 'setCurrGrade', 'setShowClose', 'setOldToken']),
      changeType(prop){
        if(!this.checkAgreement){
          return this.ShowToast('请先同意用户协议及隐私政策!');
        }
        this.type = prop;
      },
      typeChange(val = this.type) {
        let {prevLoginType: prev} = this;
        if (val === 'phone') {
          if (prev === 'phone-pwd' || prev === 'phone-code') {
            this.type = prev;
          } else {
            this.type = 'phone-code';
          }
          return;
        }
        this.codeStatus = true;
        this.showPwd = false;
        switch (this.type) {
          case 'phone-pwd':
            this.form = {
              phone: this.form.phone || '',
              password: '',
            };
            break;
          case 'setting-pwd':
            this.form = {
              phone: this.form.phone || '',
              password: '',
              verifycode: '',
              verifycode_id: '',
            };
            break;
          case 'phone-code':
          case 'bind-phone':
            this.form = {
              phone: this.form.phone || '',
              verifycode: '',
              verifycode_id: '',
            };
            break;
        }
        if (this.type !== this.value) {
          this.value = this.type;
          this.$emit('input', this.type);
        }
      },
      async sendCode(next, unlock) {
        let {form} = this;
        let tvm = this.$refs.inner;
        tvm = tvm[0] || tvm;
        if (!form.phone) {
          unlock();
          return this.ShowToast('请输入手机号！', tvm);
        } else if (!this.Tools.isPhone(form.phone)) {
          unlock();
          return this.ShowToast('请输入正确手机号！', tvm);
        } else if (!this.codeStatus) {
          return;
        }
        this.codeStatus = false;  
        this.http.getPhoneCode({
          phone: form.phone,
          sign_type: 1,
        }).then(res => {
          form.verifycode_id = res.verifycode_id;
          next();
        }).catch(err => {
          unlock();
          this.codeStatus = true;
          this.ShowToast(err.msg, tvm);
        });
      },
      phoneLoginSubmit() {
        let {type, form, lockSubmit, wxBind} = this;
        if (lockSubmit) return;
        let tvm = this.$refs.inner;
        tvm = tvm[0] || tvm;
        if (!form.phone) {
          return this.ShowToast('请输入手机号！', tvm);
        } else if (!this.Tools.isPhone(form.phone)) {
          return this.ShowToast('请输入正确手机号！', tvm);
        } else if ((type === 'phone-code' || type === 'bind-phone' || type === 'setting-pwd') && (!form.verifycode_id || !form.verifycode)) {
          if (!form.verifycode_id) {
            return this.ShowToast('请先获取验证码！', tvm);
          } else if (!form.verifycode) {
            return this.ShowToast('请输入验证码！', tvm);
          }
        } else if ((type === 'phone-pwd' || type === 'setting-pwd') && !form.password) {
          return this.ShowToast('密码不能为空！', tvm);
        }
				
        this.lockSubmit = true;
        let params = {
          ...form,
          ...this.Product,
          uid: this.userInfo.uid,
          ...wxBind,
        };
        let api = type === 'bind-phone' ? wxBind.openid ? 'NEWWxBind' : 'bindPhone' : type === 'setting-pwd' ? 'updatePassword' : 'NEWLogin';
        if (api === 'NEWWxBind') {
          let nickname = params.nickname.split('').map(s => '\\u' + ('0000' + s.codePointAt(0).toString(16)).slice(-4)).join('');
          params.nickname = nickname;
          params.content.nickname = nickname;
        }
        this.http[api](params, {
          needToken: false,
          needCancel: 'left'
        }).then(res => {
          setTimeout( () => { this.lockSubmit = false;},3000);
          if (type === 'bind-phone') {
            this.ShowToast('绑定成功！');
            setTimeout(() => {
              this.bindSucc(res);
            }, 1500);
          } else if (type === 'setting-pwd') {
            this.ShowToast('密码设置成功！');
            if (!this.userInfo.uid) {
              this.type = 'phone-pwd';
            } else {
              setTimeout(() => {
                this.pwdSucc(res);
              }, 1500);
            }
          } else {
            this.ShowToast('登录成功！');
            setTimeout(() => {
              this.loginSucc(res);
            }, 1500);
          }
        }).catch(err => {
          if (this.$listeners.error) {
            this.$emit('error', err, tvm);
          } else {
            this.ShowToast(err.msg || '网络错误！', tvm);
          }
          this.lockSubmit = false;
        });
      },
      countdownEnd(vm) {
        this.codeStatus = true;
      },
      async loginSucc(res) {
        this.setShowClose(false);
        this.setNewApiToken(res.token);
        this.setOldToken(res.old_token);
        this.setPrevLoginType(this.type);
        let userInfo = await this.GetUserInfoApi(res.uid);
        await this.SetUserGradeInfo(userInfo);
        this.type = '';
        this.ShowUserGiftImg(res,()=>{
          this.$nextTick(()=>{
						location.reload();
					}) 
        });
        this.$emit('login-success', userInfo);
      },
      async bindSucc(res) {
        this.setShowClose(false);
        this.wxBind.openid && this.setNewApiToken(res.token) && this.setOldToken(res.old_token);;
        let userInfo = await this.GetUserInfoApi(this.wxBind.openid ? res.uid : this.userInfo.uid);
        await this.SetUserGradeInfo(userInfo);
        // if (this.wxBind.openid && !userInfo.nianji_id) {
        //   this.SelectGrade();
        // }
        this.type = '';
        this.ShowUserGiftImg(res,()=>{
          location.reload();
        });
        this.$emit('bind-success', userInfo);
      },
      async pwdSucc(res) {
        this.ShowUserGiftImg(res);
        let userInfo = await this.GetUserInfoApi(this.userInfo.uid);
        this.type = '';
        this.$emit('pwd-success', userInfo);
      },
      // 跳转用户协议和隐私政策
      changeEvent(prop) {
        this.OpenRouter(`/footer/details?type=${prop}`);
      },
			changeInput(name){
				let {form} = this;
				let value = form[name]
				//限制输入中文
				form[name] = value.replace(/[\u4E00-\u9FA5 ]/g, '');
			},
    },
  }
</script>

<style scoped lang="less">

  @import "../../assets/less/function";

  .bind-error {
    background-color: rgba(0, 0, 0, .3);
    &-box {
      padding: 41px 30px 29px;
      width: 304px;
      background: #fff;
      border-radius: 8px;
    }
    .header {
      margin-bottom: 9px;
      font-size: 16px;
      color: #333f4e;
      line-height: 24px;
      .red {
        color: #ff4436;
      }
    }
    .qr-code {
      margin-bottom: 10px;
      width: 142px;
      height: 142px;
    }
    .footer {
      margin-bottom: 16px;
      font-size: 14px;
      color: #999fa6;
    }
    .phone {
      font-size: 16px;
      color: #333f4e;
    }
  }

  .df-input {
    background-color: #fff;
    border-radius: 8px;
    /deep/ .ivu-input {
      padding: 12px 16px;
      height: 40px;
      line-height: 1;
      box-sizing: border-box;
      color: #333f4e;
      border: 0;
      outline: 0;
      box-shadow: none;
      :-ms-input-placeholder {
        font-size: 14px;
        color: #999fa6;
      }
    }
  }

  .forget-pwd {
    margin-bottom: 7px;
    line-height: 28px;
    font-size: 12px;
    color: #999fa6;
    &:hover {
      color: #1177ff;
    }
  }

  .login-submit {
    border-radius: 8px;
    background-color: #1177ff;
    color: #fff;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    &:hover {
      background-color: #0066ed;
    }
  }

  .login-icon {
    .spirit(url(../../assets/images/1_login_icon.png));
    &.ico-1 {
      &:after {
        width: 28px;
        height: 28px;
        background-position: -11px -16px;
      }
    }
    &.ico-2 {
      margin-right: 10px;
      &:after {
        width: 18px;
        height: 18px;
        background-position: -45px -21px;
      }
    }
    &.ico-3 {
      margin-right: 10px;
      &:after {
        width: 18px;
        height: 18px;
        background-position: -69px -21px;
      }
    }
    &.ico-5 {
      margin: 0 16px 0 109px;
      &:after {
        width: 30px;
        height: 24px;
        background-position: -174px -17px;
      }
    }
    &.ico-6 {
      margin: 0 21px 0 115px;
      &:after {
        width: 19px;
        height: 27px;
        background-position: -211px -16px;
      }
    }
    &.ico-7 {
      &:after {
        width: 22px;
        height: 18px;
        background-position: -15px -55px;
      }
    }
    &.ico-8 {
      &:after {
        width: 16px;
        height: 10px;
        background-position: -46px -59px;
      }
    }
    &.ico-9 {
      &:after {
        width: 16px;
        height: 10px;
        background-position: -71px -59px;
      }
    }
    &.ico-11 {
      line-height: 40px;
      &:after {
        width: 18px;
        height: 11px;
        background-position: -115px -59px;
      }
    }
    &.ico-12 {
      line-height: 40px;
      &:after {
        width: 18px;
        height: 16px;
        background-position: -145px -55px;
      }
    }
    &.ico-13 {
      top: 8px;
      right: 8px;
      &:after {
        width: 23px;
        height: 24px;
        background-position: -178px -52px;
      }
    }
  }

  .close {
    top: 18px;
    right: 24px;
  }

  .has-bg {
    background: rgba(0, 0, 0, .7);
  }

  .login {
    height: 456px;
    border-radius: 8px;
  }

  .right-inner {
    padding: 60px 52px 0;
  }

  .login-left {
    width: 296px;
    background: url(../../assets/images/login/login_pic.png) no-repeat top left / 100% 100%, linear-gradient(0, #1177FF, #4B99FF);
    border-radius: 8px 0 0 8px;
    color: #fff;
    font-size: 16px;
    line-height: 1;
    &.bind-phone-left {
      background: radial-gradient(circle at 50% calc(100% + 67px), rgba(255, 255, 255, .05), rgba(255, 255, 255, .05) 220px, transparent 220px),
      radial-gradient(circle at 50% 120px, rgba(255, 255, 255, .1), rgba(255, 255, 255, .1) 56px, transparent 56px),
      linear-gradient(0, #1177FF, #4B99FF);
      .left-bg {
        display: block;
        width: 297px;
        left: -21px;
        bottom: -19px;
      }
      .user-avatar {
        margin: 76px 0 40px;
        width: 88px;
        height: 88px;
        border-radius: 50%;
        background-color: #fff;
      }
      .user-name {
        margin-bottom: 24px;
      }
      .user-name-inner {
        font-size: 18px;
      }
    }
  }

  .login-right {
    width: 448px;
    background-color: #fff;
    border-radius: 0 8px 8px 0;
    .login-tip {
      font-size: 16px;
      color: #666f7a;
      line-height: 1;
      .big {
        font-family: MicrosoftYaHei-Bold;
        margin-right: 14px;
        font-size: 20px;
        font-weight: bold;
        color: #000F22;
      }
    }
  }

  .home {
    .inner {
      margin-top: 78px;
      .to {
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        color: #fff;
        border-radius: 48px;
        background-color: #f5991f;
        &:hover {
          background-color: #ed8e10;
        }
      }
      .to-wx {
        margin-bottom: 32px;
        background-color: #00c250;
        &:hover {
          background-color: #09b43f;
        }
      }
      .to-phone {
        margin-bottom: 60px;
      }
    }
  }

  .agreement {
    font-size: 14px;
    color: #999fa6;
  }

  .to-agreement {
    color: #1177ff;
  }

  .change-phone {
    margin: 35px 0 15px;
    font-size: 14px;
    color: #F5991F;
    .login-icon {
      line-height: 0;
    }
  }

  .wx {
    .qr-code-inner {
      margin: 34px auto 11px;
      width: 170px;
      height: 170px;
    }
    .message {
      font-size: 16px;
      color: #666f7a;
    }
  }

  .phone-code,
  .bind-phone,
  .setting-pwd,
  .phone-pwd {
    .inner {
      margin-top: 24px;
      padding: 0 18px 16px;
      border-radius: 10px;
      background-color: #eeeeee;
      + .change-phone {
        margin-top: 23px;
        color: #00c250;
      }
    }
    .phone-input {
      margin-bottom: 16px;
    }
    .code-input {
      margin-bottom: 24px;
      .send-code-btn {
        padding-right: 16px;
        height: 15px;
        font-size: 14px;
        line-height: 1;
        color: #999fa6;
        border-left: 1px solid #999fa6;
      }
      &.can-click {
        .send-code-btn {
          color: #1177ff;
          border-left-color: #1177ff;
        }
      }
    }
  }

  .bind-phone {
    .login-tip {
      margin-bottom: 40px;
      flex-direction: column;
      align-items: center;
      .big {
        margin: 0 0 10px;
      }
    }
    .inner {
      background-color: transparent;
    }
    .df-input {
      background-color: #eee;
      /deep/ .ivu-input {
        background-color: transparent;
      }
    }
    .bind-tip {
      margin-top: 55px;
      font-size: 14px;
      color: #999fa6;
    }
    .kf {
      color: #1177ff;
    }
  }

  .setting-pwd {
    .login-tip {
      .small {
        display: none;
      }
    }
    .inner {
      padding-top: 20px;
    }
    .code-input {
      margin-bottom: 16px;
    }
    .pwd-input {
      margin-bottom: 24px;
    }
  }

  .change-phone-type {
    padding: 0 72px;
    font-size: 14px;
    color: #666f7a;
    line-height: 48px;
    > :not(.active) {
      &:hover {
        color: #1177ff;
      }
    }
    .active {
      font-size: 16px;
      font-weight: bold;
      color: #1177ff;
    }
    .popup {
      white-space: nowrap;
      /deep/ .triangle-popup {
        bottom: -14px;
      }
    }
  }
</style>